import script from "./CoinSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoinSelect.vue?vue&type=script&lang=ts&setup=true"

import "./CoinSelect.vue?vue&type=style&index=0&id=0cd3391d&lang=scss"

const __exports__ = script;

export default __exports__